//importaciones de imágenes  productos de línea y especiales

import image1 from '../assets/images/maqueta/img1.jpg'
import image2 from '../assets/images/maqueta/img2.jpg'
import image3 from '../assets/images/maqueta/img3.jpg'
import image4 from '../assets/images/maqueta/img4.jpg'
import image5 from '../assets/images/maqueta/img5.jpg'
import image6 from '../assets/images/maqueta/img6.jpg'
import image7 from '../assets/images/maqueta/img7.jpg'
import image8 from '../assets/images/maqueta/img8.jpg'
import image9 from '../assets/images/maqueta/img9.jpg'
import image10 from '../assets/images/maqueta/img10.jpg'
import image11 from '../assets/images/maqueta/img11.jpg'

//importaciones de imágenes marcas de productos

import imgPostes from '../assets/images/brand/products/Logo-Isologo-Horizontal_p10_color.png'
import imgTejalite from '../assets/images/brand/products/Logo-Isologo-Horizontal_tejalite_color.png'
import imgTensoblock from'../assets/images/brand/products/Logo-Isologo-Horizontal_tensoblock_color.png'
import imgTensoquines from '../assets/images/brand/products/Logo-Isologo-Horizontal_tensoquines_color.png'
import imgT21 from '../assets/images/brand/products/Logo-Isologo-Horizontal_t21_color.png'
import imgT180 from '../assets/images/brand/products/Logo-Isologo-Horizontal_t180_color.png' 
import imgCercalite from '../assets/images/brand/products/isologo-cercalite.svg' 

//importación de íconos
import icon1 from '../assets/images/icons/tensoquines.svg'
import icon2 from '../assets/images/icons/bloques tensoblock.svg'
import icon3 from '../assets/images/icons/Viguetas T21.svg'
import icon4 from '../assets/images/icons/viguetas T180.svg'
import icon5 from '../assets/images/icons/Tejas tejalites.svg'
import icon6 from '../assets/images/icons/postes_p10.svg'

//importación de íconos especiales
import estructurasIconW from '../assets/images/icons/Tensolite Estructuras.svg'
import especialOtrosIconW from '../assets/images/icons/Tensolite Otros.svg'
import pasarelasIconW from '../assets/images/icons/Tensolite Pasarelas.svg'
import tribunasIconW from '../assets/images/icons/tensotribunas.svg'
import vigasIconW from '../assets/images/icons/tensovigas.svg'

export default [
    [   
        {id: '1', name: 'Tensoquines', image: image1, icon: icon1 },
        {id: '2', name: 'Tensoblock', image: image2, icon: icon2},
        {id: '3', name: 'T21', image: image3, icon: icon3},
        {id: '4', name: 'T180', image: image11, icon: icon4},
        {id: '5', name: 'Tejalite', image: image4, icon: icon5},
        {id: '6', name: 'P10', image: image5, icon: icon6}
    ], 
    [// productos especiales
        {id: '7', name: 'Estructuras', image: image6, icon: estructurasIconW},
        {id: '8', name: 'Tribunas', image: image7, icon: tribunasIconW},
        {id: '9', name: 'Vigas', image: image8, icon:vigasIconW},
        {id: '10', name: 'Pasarelas', image: image9, icon: pasarelasIconW},
        {id: '11', name: 'Otros', image: image10, icon: especialOtrosIconW}
    ],
    [
        {id: '16', name: 'VigT21', image: imgT21}, 
        {id: '14', name: 'TensoB', image: imgTensoblock},
        {id: '17', name: 'Vigt180', image: imgT180},
        {id: '15', name: 'Tensoq', image: imgTensoquines},
        {id: '13', name: 'Teja', image: imgTejalite},
        {id: '12', name: 'Postes', image: imgPostes},
        {id: '18', name: 'Cercalite', image: imgCercalite},
        {id: '16', name: 'VigT21', image: imgT21}, 
        {id: '14', name: 'TensoB', image: imgTensoblock},
        {id: '17', name: 'Vigt180', image: imgT180},
        {id: '15', name: 'Tensoq', image: imgTensoquines},
        {id: '13', name: 'Teja', image: imgTejalite},
        {id: '12', name: 'Postes', image: imgPostes},
        {id: '18', name: 'Cercalite', image: imgCercalite},
        {id: '16', name: 'VigT21', image: imgT21}, 
        {id: '14', name: 'TensoB', image: imgTensoblock},
        {id: '17', name: 'Vigt180', image: imgT180},
        {id: '15', name: 'Tensoq', image: imgTensoquines},
        {id: '13', name: 'Teja', image: imgTejalite},
        {id: '12', name: 'Postes', image: imgPostes},
        {id: '18', name: 'Cercalite', image: imgCercalite},
    ],
    
]